export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const login = (user,op) => {
  return {
    type: LOGIN,
    payload: user,
    optype:op
  };
};

export const logout = () => {
  return {
    type: LOGOUT
  };
};